<template>
  <v-card-text>
    <v-row dense class="mb-2">
     
        <!-- <branch-offices-list
          :model="idBranchOfficeSelected"
          v-on:triggerChange="branchOfficeSelected"
          dense
        /> -->
      
      <v-col>
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
        dense
      />
      </v-col>
      
    </v-row>
    <v-data-table
      :headers="headers"
      :items="listHisClinic"
      :search="search"
      :items-per-page="10"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      dense
      fixed-header
      height="auto"
      hide-default-footer
    >
      <template v-slot:[`item.registrationDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.registrationDate) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          top
          v-if="$utilFront.withPermission($prm.VIEW_CLINIC_HISTORY)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon @click="getInfoOfPatient(item.idPatient)">
              <v-icon color="secondary" v-bind="attrs" v-on="on">
                {{ icono.icon }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ icono.tooltip }}</span>
        </v-tooltip>
        <span v-else> - - - </span>
      </template>
    </v-data-table>
    <v-row dense>
      <v-col cols="8" md="8" sm="8" offset="2" class="text-center">
        <paginatesx
          :click-handler="changePage"
          :page-count="pageCount"
          :page-range="1"
          :margin-pages="1"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'page-item'"
        >
        </paginatesx>
      </v-col>
      <v-col cols="2" md="2" sm="2" class="text-center mt-5">
        <v-banner outlined single-line> Total: {{ totalCount }}</v-banner>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import ClinicHistoryService from "@/app/services/ClinicHistoryService";
import BranchOfficesList from "@/components/BranchOfficesList.vue";

import { PatientRequest } from "@/core/request";
import moment from "moment";
import { mapActions } from "vuex";
export default {
  components:{
    BranchOfficesList
  },
  props: {
    getInfoOfPatient: Function,
  },
  data() {
    return {
      idBranchOfficeSelected: null,
      itemsPerPage: 10,
      pageCount: 1,
      currentPage: 1,
      totalCount: 0,
      listHisClinic: [],
      search: "",
      searchDelay: null,
      icono: {
        icon: "mdi-information-variant",
        color: "blue",
        tooltip: "Ver información",
      },
      headers: [
        { text: "Id Paciente", value: "idPatient", align: "center" },
        { text: "CURP", value: "curp", align: "center" },
        { text: "Nombre del paciente", value: "fullName", align: "center" },
        {
          text: "Teléfono",
          value: "contactInformation.phone",
          align: "center",
        },
        { text: "Correo", value: "contactInformation.email", align: "center" },
        {
          text: "Fecha de registro",
          value: "registrationDate",
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
    };
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
    },
  },
  mounted() {
    this.listAllPagination();
    // this.listClinicHistory();
  },
  methods: {
    ...mapActions(["unauthorized"]),
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
    },
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
      let params = {
        search: this.search,
        maxResults: this.itemsPerPage,
        page: this.currentPage,
        idBranchOffice: this.idBranchOfficeSelected
      };

      this.$emit("loaderTable", true);

      ClinicHistoryService.listAllPagination(params)
        .then((response) => {
          const { count, list } = response.data;

          this.listHisClinic = list;
          this.totalCount = count;
          this.pageCount = Math.ceil(count / this.itemsPerPage);

          if (
            (count > 0 &&
              this.$utilFront.isEmptyList(list) &&
              this.currentPage > 1) ||
            this.currentPage > this.pageCount
          ) {
            this.changePage(1);
          }
        })
        .finally(() => {
          this.$emit("loaderTable", false);
        });
    },
    listClinicHistory() {
      let data = {
        idBranchOffice: "",
      };
      PatientRequest.listPatientsByDate(data)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.listHisClinic = res.data.data.map((patient) => {
              patient.registrationDate =
                patient.registrationDate != null
                  ? moment(new Date(patient.registrationDate)).format(
                      "DD/MM/YYYY HH:mm"
                    )
                  : "--";
              patient.email = patient.email != null ? patient.email : "----";
              patient.phone = patient.phone != null ? patient.phone : "----";
              return patient;
            });

            console.log(this.listHisClinic[0]);
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Error al consultar la información, intente nuevamente",
              "ERROR"
            );
          }
        })
        .catch((e) => {
          this.$utilFront.notifications(
            "Ha ocurrido un error interno",
            "ERROR"
          );
        })
        .finally(() => {});
    },
  },
};
</script>

<style></style>
